import React from 'react';
import '../styles/footer.css';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="custom-footer">
            <div className="container footer-grid">

                {/* Brand */}
                <div className="footer-section">
                    <h4 className="footer-title">TippBázis</h4>
                    <p className="footer-text">
                        Stratégia-alapú sportfogadási statisztikák és elemzések.
                    </p>
                </div>

                {/* Menü */}
                <div className="footer-section">
                    <h6 className="footer-heading">Navigáció</h6>
                    <ul>
                        <li><a href="/kezdolap">Kezdőlap</a></li>
                        <li><a href="/strategiak">Stratégiák</a></li>
                        <li><a href="/szavazas">Szavazás</a></li>
                        <li><a href="/meccselemzo">Statisztikák</a></li>
                        <li><a href="/jegyzetek">Jegyzetek</a></li>
                        {/* <li><a href="/kalkulator-odds">Odds Kalkulátor</a></li>
                        <li><a href="/kalkulator-bankroll">Bankroll Kalkulátor</a></li> */}
                    </ul>
                </div>
                <div className="footer-section">
                    <h6 className="footer-heading">Információk</h6>
                    <ul>
                        <li><a href="/sportfogadas-statisztika">Sportfogadási statisztikák</a></li>
                    </ul>
                </div>

                {/* Információ */}
                <div className="footer-section">
                    <h6 className="footer-heading">Információ</h6>
                    <ul>
                        <li>
                            <Link to={"/kapcsolat"}>Kapcsolat</Link>
                        </li>
                        <li>
                            <Link to={"/aszf"}>ÁSZF</Link>
                        </li>
                        <li>
                            <Link to={"/adatkezeles"}>Adatkezelés</Link>
                        </li>
                    </ul>
                </div>

                {/* Extra */}
                <div className="footer-section">
                    <h6 className="footer-heading">Státusz</h6>
                    <p className="footer-text small">
                        Verzió: <strong>v1.0</strong><br />
                    </p>
                </div>

            </div>

            <div className="footer-bottom">
                © 2025 TippBázis — Minden jog fenntartva.
            </div>
        </footer>
    );
}